import { ReactChild } from 'react';

import './DialogActionGroup.light.scss';
import './DialogActionGroup.dark.scss';

interface Props {
  children: ReactChild | ReactChild[];
}

export function DialogActionGroup(props: Props) {
  return (
    <div className='dialog-action-group'>
      {
        props.children
      }
    </div>
  );
}
